import { render, staticRenderFns } from "./ZButton.vue?vue&type=template&id=a872e366&scoped=true&"
import script from "./ZButton.vue?vue&type=script&lang=js&"
export * from "./ZButton.vue?vue&type=script&lang=js&"
import style0 from "./ZButton.vue?vue&type=style&index=0&id=a872e366&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a872e366",
  null
  
)

component.options.__file = "ZButton.vue"
export default component.exports